module.exports = __webpack_public_path__ + "static/illustration-about-4364f6451d8d6b88fb47ec4c3dc213e6.png";